import React, { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import styles from "./Weather.module.scss";

function Weather() {
  const { t } = useTranslation('common')
  const [query, setQuery] = useState("Bishkek");
  const [weather, setWeather] = useState({
    loading: false,
    data: {},
    error: false,
  });

  const toDate = () => {
    const months = [
        t('weather.month_january'), t('weather.month_february'), t('weather.month_march'), t('weather.month_april'),
        t('weather.month_may'), t('weather.month_june'), t('weather.month_july'), t('weather.month_august'),
        t('weather.month_september'), t('weather.month_october'), t('weather.month_november'), t('weather.month_december'),
    ];

    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth();

    const formattedDate = `${day}, ${months[month]}`;
    return formattedDate;
};


  const toDate1 = () => {

    const days = [
      t('weather.day_sunday'),
      t('weather.day_monday'),
      t('weather.day_tuesday'),
      t('weather.day_wednesday'),
      t('weather.day_thursday'),
      t('weather.day_friday'),
      t('weather.day_saturday'),
    ];
    const currentDate = new Date();
    const date = `${days[currentDate.getDay()]}`;
    return date;
  };
  const search = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setQuery('');

      setWeather({ ...weather, loading: true });
      const url = 'https://api.openweathermap.org/data/2.5/weather';
      const appid = 'f00c38e0279b7bc85480c3fe775d518c';

      await axios
        .get(url, {
          params: {
            q: query,
            units: 'metric',
            appid: appid,
          },
        })
        .then((res) => {

          setWeather({ data: res.data, loading: false, error: false });
        })
        .catch((error) => {
          setWeather({ ...weather, data: {}, error: true });
          setQuery('');

        });
    }

  };
  const infoweather = async (queryinfo) => {

    setWeather({ ...weather, loading: true });
    const url = 'https://api.openweathermap.org/data/2.5/weather';
    const appid = 'f00c38e0279b7bc85480c3fe775d518c';

    await axios
      .get(url, {
        params: {
          q: queryinfo,
          units: 'metric',
          appid: appid,
        },
      })
      .then((res) => {

        setWeather({ data: res.data, loading: false, error: false });
      })
      .catch((error) => {
        setWeather({ ...weather, data: {}, error: true });
        setQuery('');

      });


  };

  useEffect(() => {



    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
      }
    }


    const showPosition = (position) => {
      const { latitude, longitude } = position.coords;
      reverseGeocode(latitude, longitude);

    }


    const reverseGeocode = async (latitude, longitude) => {
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
        const data = await response.json();
        const fullCityName = data.address.city || data.address.town || data.address.village || data.address.county || data.address.state || 'Unknown';
        const cityNameArray = fullCityName.split(' ');

        const lastWord = cityNameArray.pop();

        const cityName = lastWord || 'Unknown';
        setQuery(cityName)
        infoweather(cityName)
      } catch (error) {
      }
    }

    getLocation();

  }, []);


  return (
    <div>


      {weather.loading && (
        <>


        </>
      )}
      {weather.error && (
        <>
          <br />

          <span className={styles.error_message}>

            <span style={{ 'font-size': '20px' }}>{t('weather.city_not_found')} </span>
          </span>
          <br />
        </>
      )}

      {weather && weather.data && weather.data.main && (
        <div className={styles.city_div}>
          <div>
            <div className={styles.city_name}>
              <h2>
                {weather.data.name}, <span>{toDate()}</span>
              </h2>
              <h2>
                <span>{toDate1()}</span>
              </h2>
            </div>


            <div className={styles.des_wind}>
              <p>{weather.data.weather[0].description.toUpperCase()}</p>
              <p>{t('weather.wind_speed')}: {weather.data.wind.speed}m/s</p>
            </div>
          </div>
          <div className={styles.icon_temp}>
            <img
              className=""
              src={`https://openweathermap.org/img/wn/${weather.data.weather[0].icon}@2x.png`}
              alt={weather.data.weather[0].description}
            />
            {Math.round(weather.data.main.temp)}
            <sup className={styles.deg}>&deg;C</sup>
          </div>
        </div>
      )}
      <div className={styles.search_bar}>
        <input
          type="text"
          className={styles.city_search}
          placeholder={t('weather.find_city')}
          name="query"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyPress={search}
        />
      </div>

    </div>

  );

}

export default Weather;
